<template lang="pug">
  .field-wallet-record-id(v-if="$is('wallet-record-id')")
    .label ID
    .field-value WR{{item.id}}

  .field-walletable(v-else-if="$is('wallet-record-walletable')")
    .label Walletable
    .field-value {{walletableType}}({{item.walletable_id}})
    //.field-value(v-for="line in item.reason.split('|')") {{ line }}

  .field-wallet-record-tax(v-else-if="$is('wallet-record-tax')")
    .label Tax
    .field-value {{currency}}{{parseFloat((item.amount *-1) * item.tax).toFixed(2)}}

  .field-wallet-record-tax-rate(v-else-if="$is('wallet-record-tax-rate')")
    .label Tax Rate
    .field-value {{item.tax*100}}%

  .field-wallet-record-amount(v-else-if="$is('wallet-record-amount')")
    .label Amount
    .field-value  {{currency}}{{item.amount}}

  .field-wallet-record-created(v-else-if="$is('wallet-record-created')")
    .label Created
    .field-value {{$dateFormat(item.created, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}

  .field-wallet-invoice(v-else-if="$is('wallet-record-invoice')")
    .label Invoice
    router-link(v-if="item.invoice.internal_id", :to="{name:'invoice', params:{id:item.invoice.id}}")
      span  INV{{item.invoice.internal_id}}
    span(v-else) Uninvoiced


</template>
<script type="text/babel">
  import {mapState} from 'vuex'

  export default {
    name: 'WalletRecordFields',
    components: {},
    data() {
      return {}
    },
    created() {
    },
    methods: {
      viewPMOnGateway() {
        var url = GatewayUrlHelper.paymentMethod(this.item.provider, this.item.data.braintree_card_token)
        window.open(url, '_blank')
      },
      viewClientOnGateway() {
        var url = GatewayUrlHelper.clientUrl(this.item.provider, this.item.data.braintree_client_id)
        window.open(url, '_blank')
      }
    },
    computed: {
      type() {
        return this.fieldName
      },
      walletableType() {
        return this.item.walletable_type.replace(/App\\Models\\/, '')
      },
      ...mapState({
        configuration: state => state.configuration,
      }),
      currency() {
        return this.configuration.commercial.commercial_currency.value
      },
    },
    props: {
      item: Object,
      fieldName: {
        type: String,
        default: ''
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// WalletRecordFields.vue?08982742